import { siteStore } from "../store";

/**
 * Returns true only if all ids in siteIds are present in the store
 */
export const hasSelectedSiteIds = (siteIds: string[]): boolean => {
  return siteIds.every((id) => siteStore.selectedSiteIds.includes(id));
};

export const getSelectedSiteIdsCount = (): number => {
  return siteStore.selectedSiteIds.length;
};

export const addSiteIdsToSelectedSiteIds = (siteIds: string[]) => {
  siteStore.selectedSiteIds = siteStore.selectedSiteIds.concat(siteIds);
};

export const removeSiteIdsFromSelectedSiteIds = (siteIds: string[]) => {
  siteStore.selectedSiteIds = siteStore.selectedSiteIds.filter((id) => {
    return !siteIds.includes(id);
  });
};

export const clearSelectedSiteIds = () => {
  siteStore.selectedSiteIds = [];
};
